export default __webpack_public_path__ + "static/media/corporate1.d8990c1c.png";